import React, { useEffect, useState } from "react";
import Header from "./Header";
import SplashCard from "./SplashCard";
import { useContext } from "react";
import { isValidHost } from "../../cf";
import { invalidHosts } from "../../app-config/routeConfig";
import SharedDataContext from "../../SharedDataContext";

export default function HowToBegin() {
  const { params } = useContext(SharedDataContext);
  console.log("params", params);
  const data1 = [
    {
      mediaSrc: "/images/ext/splash/img1.svg",
      heading: "Prospect profile",
      info: `Fetch contacts details of prospects, see their company information and add them to lists for easy searching.`,
      link: (
        <a
          target="_blank"
          href="https://www.linkedin.com/in/williamhgates/"
          className="bg-background  dark:bg-blue-100 rounded-[8px] py-2 px-3 text-white mt-1 inline-block"
        >
          Try now
        </a>
      ),
    },
    {
      mediaSrc: "/images/ext/splash/img2.svg",
      heading: "Firmographic data",
      info: `Navigate to a company’s profile page to see firmographic data of the company and assess the see how well it fits your ICP.`,
      link: (
        <a
          target="_blank"
          href="https://www.linkedin.com/company/apple/"
          className="bg-background  dark:bg-blue-100 rounded-[8px] py-2 px-3 text-white mt-1 inline-block"
        >
          See example
        </a>
      ),
    },
  ];

  const data2 = [
    {
      mediaSrc: "/images/ext/splash/img4.svg",
      heading: "Prospecting through LinkedIn",
      info: `Find contact details of prospects, see firmographic data on company profile pages and bulk import contacts from people search/sales navigator.`,
      link: (
        <a
          target="_blank"
          href="https://www.linkedin.com/"
          className="bg-background  dark:bg-blue-100 rounded-[8px] py-2 px-3 text-white mt-1 inline-block"
        >
          Try now
        </a>
      ),
    },
    {
      mediaSrc: "/images/ext/splash/img2.svg",
      heading: "Company assessment",
      info: `Instantly get a company’s firmographic data while browsing its website. This will enable you to immediately see if it fits your ICP and start finding prospects for it.`,
      link: (
        <a
          target="_blank"
          href="https://www.apple.com/"
          className="bg-background  dark:bg-blue-100 rounded-[8px] py-2 px-3 text-white mt-1 inline-block"
        >
          See example
        </a>
      ),
    },
  ];

  const [data, setData] = useState([]);
  useEffect(() => {
    if (params && params?.infoPage) {
      const isValid = params?.url === null ? true : isValidHost(params?.url, invalidHosts);
      if (isValid) {
        setData(data1);
      } else {
        setData(data2);
      }
    }
  }, [params && params?.infoPage]);

  return (
    <>
      <Header homeLink="/contact-viewer/how-to-begin" />
      <div className="space-y-3 p-3">
        {data &&
          data.map((obj) => (
            <SplashCard mediaSrc={obj.mediaSrc} heading={obj.heading} info={obj.info} link={obj.link} />
          ))}
      </div>
    </>
  );
}
